import { useTranslation } from "@refinedev/core";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";
import ReactPaginate from "react-paginate";
import { Pagination as NewPagination } from "components/pagination";

import "./styles.scss";

interface PropType {
  showTotal: boolean;
  paging: any;
  centerPagination?: boolean;
  handlePageChange: (page: number) => void;
}

const Pagination = (props: PropType) => {
  const { showTotal, paging, centerPagination, handlePageChange } = props;

  const { translate } = useTranslation();

  const handlePageClick = (e: any) => {
    handlePageChange(e.selected + 1);
  };

  return (
    <div
      id="pagination"
      className={`flex items-center ${
        showTotal
          ? "justify-between"
          : centerPagination
          ? "justify-center"
          : "justify-end"
      }`}
    >
      {showTotal && (
        <div className="text-[14px] font-[500] w-[200px]">
          {translate("total")}: {paging?.total_item}/{paging?.total}
        </div>
      )}

      {/* <ReactPaginate
        breakLabel="..."
        nextLabel={<ChevronRightIcon className="icon-next-page" />}
        className="paging"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={paging?.total_page}
        activeClassName="active"
        previousLabel={<ChevronLeftIcon className="icon-next-page" />}
        forcePage={paging?.current_page - 1}
      /> */}

      <NewPagination
        hideTotal
        currentPage={paging?.current_page}
        totalPage={paging?.total_page}
        total={{
          totalItems: paging?.total_item,
          total: paging?.total,
        }}
        onChange={(page: number) => handlePageChange(page)}
      />
    </div>
  );
};

export default Pagination;
